import { render, staticRenderFns } from "./channelAccountManagement.vue?vue&type=template&id=705ed201&scoped=true"
import script from "./channelAccountManagement.vue?vue&type=script&lang=js"
export * from "./channelAccountManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705ed201",
  null
  
)

export default component.exports